import "./index.css";

import { ClerkProvider } from "@clerk/clerk-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { HelmetProvider } from "react-helmet-async";
import { dbStorage } from "./utils/dbStorage";
import { router } from "./router";

let posthog;
try {
  import("./lib/posthog").then(module => { posthog = module.default; })
    .catch(error => { console.warn("PostHog import failed:", error); });
} catch (error) {
  console.warn("Error importing PostHog:", error);
}

// Get the clerk public key from the environment
const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Initialize the IndexedDB database
dbStorage.init().catch(err => {
  console.error("Failed to initialize IndexedDB:", err);
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <ClerkProvider
        publishableKey={clerkPubKey}
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        appearance={{
          layout: {
            animations: false,
            shimmer: false,
          },
        }}
      >
        <RouterProvider router={router} />
      </ClerkProvider>
    </HelmetProvider>
  </React.StrictMode>
);
